import React, { useState, useEffect } from "react";
import { apiCall } from "../utils/Api";
import Comment from "./Comment";
import { Button, message, Space } from "antd";
import { useSession } from "../utils/Session";
export default function Comments(props) {

    const { isbn = "", row = false, comments = false } = props;
    const [results, setResults] = useState((comments) ? comments : []);
    const [session, setSession] = useSession(); 

  

    const getComments = () => {

        let request = {};
        request.isbn = isbn;
        if (props.titlelist_id) {
            request.titlelist_id = props.titlelist_id;
        }

        apiCall("title/getComments", request, (_status, _result) => {
            if (_status) {
                setResults(_result);
            }
        })
    }

    


    const highlight = () => {

        let obj = {
            isbn : isbn,
            comment : "*Highlight",
            shared_with : 1,
            expiry_type : 1,
            expiry_days : 90,
            as_author : "personal"
        }

        if (props.titlelist_id) {
            obj.titlelist_id = props.titlelist_id;
        }

        

        apiCall("comment/add", obj, (_status, _result) => {
            if(_status){
                message.success("Highlight Added");
                getComments(); 
            } else {
                message.error(_result.error);
            }
        })
    }


    const drawComments = () => {
        if (results.length < 1) {
            return (<></>)
        }
        
        return results.sort((a, b) => b.modified - a.modified).map((item, index) => {
            return (
                <div key={index}>
                    <Comment.Display callback={getComments} key={index} data={item} />
                    {((index + 1) !== results.length) && <><div className="shim"></div><div className="shim"></div></>}
                </div>
            )
        })
    }

    if (row) {
        return (
            <>
                <div style={{ "float": "left" }}>
                    <Space>
                    <Comment titlelist_id={props.titlelist_id} isbn={isbn} opennew data={{ text: "" }} callback={getComments} >
                        <Button className="mini-btn" size="small"><small>New Comment</small></Button>
                    </Comment>
                    {(session.is_store && <Button onClick={() => highlight()} className="mini-btn" size="small"><small>Highlight</small></Button>)}
                    </Space>
                    <div className="shim" /><div className="shim" />
                </div>
                <br clear="all" />
                <div style={{ "padding": "0px" }}>
                    <div className="shim" />
                    {drawComments()}
                    <div className="shim" />
                </div>
            </>
        )
    }

    return (<>
        <div style={{ "padding": "0px" }}>
            <div className="shim" />
            {drawComments()}
            <div className="shim" />
        </div>
    </>
    )



}